import Dispatcher from "../dispatcher";

export default {
  addBookmark(isbn) {
    Dispatcher.emit(Dispatcher.BOOKMARKS_ADD, isbn);
  },

  removeBookmark(isbn, guid) {
    Dispatcher.emit(Dispatcher.BOOKMARKS_DELETE, isbn, guid);
  }
};
